import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["partId", "price", "description", "descriptionEn", "salesDeText", "salesEnText"]

  select(event) {
    const article = JSON.parse(event.detail.selected.dataset.stockArticle)
    this.priceTarget.value = article.price ?? ""
    this.descriptionTarget.value = article.description ?? ""
    this.descriptionEnTarget.value = article.descriptionEn ?? ""
    this.setText(this.salesDeTextTarget, article.salesDeText)
    this.setText(this.salesEnTextTarget, article.salesEnText)
  }

  clearArticle() {
    // Clear immediately; autocomplete clears its ID only after its debounce.
    this.partIdTarget.value = ""
    this.priceTarget.value = ""
    this.descriptionTarget.value = ""
    this.descriptionEnTarget.value = ""
    this.setText(this.salesDeTextTarget, "")
    this.setText(this.salesEnTextTarget, "")
  }

  setText(target, html) {
    if (target.editor) {
      target.editor.loadHTML(html || "")
    } else {
      target.value = html || ""
    }
  }
}
